/// <amd-module name="Environments/EnvironmentsSecurity/ActionsCreators/EnvironmentsSecurityActionsCreator" />
import { ActionCreatorBase } from "Environments/Flux/ActionCreatorBase";
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { MessagesActions } from "Environments/EnvironmentsCommon/MessagesActions";

import { IEnvironmentService } from "Environments/Client/EnvironmentService";
import * as Contracts from "DistributedTask/Client/Contracts/TaskAgent";
import { IVssPageContext } from "VSS/Platform/Context";
import { EnvironmentSecurityActions } from "Environments/EnvironmentsSecurity/Actions/EnvironmentsSecurityActions";
import { PageKey } from "Environments/EnvironmentsSecurity/Common/Utils";

export class EnvironmentsSecurityActionsCreator extends ActionCreatorBase {
    public static getKey(): string {
        return "environments-security-action-creator";
    }

    public initialize(instanceId?: string) {
        super.initialize(instanceId);

        this._actions = ActionsHubManager.CreateActionsHub<EnvironmentSecurityActions>(EnvironmentSecurityActions, instanceId);
        this._messageActions = ActionsHubManager.CreateActionsHub<MessagesActions>(MessagesActions, instanceId);
    }

    public getEnvironmentById(pageContext: IVssPageContext, environmentId: number, includeSGReferences: boolean = true) {
        const expands: Contracts.EnvironmentExpands = includeSGReferences ? Contracts.EnvironmentExpands.ResourceReferences : Contracts.EnvironmentExpands.None;
        pageContext.getService<IEnvironmentService>("IEnvironmentService").getEnvironmentById(environmentId, expands).then((environment: Contracts.EnvironmentInstance) => {
            this._actions.setEnvironment.invoke(environment);
        },
        (error) => {
            this._messageActions.addMessage.invoke({ key: PageKey.EnvironmentsSecurityView, value: error.message || error });
        });
    }

    protected disposeInternal(): void {
        ActionsHubManager.DeleteActionsHub<EnvironmentSecurityActions>(EnvironmentSecurityActions, this.getInstanceId());
        ActionsHubManager.DeleteActionsHub<MessagesActions>(MessagesActions, this.getInstanceId());
    }

    private _actions: EnvironmentSecurityActions;
    private _messageActions: MessagesActions;
}
